import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';
import { CreateAgentFirmProps } from './types';

export async function createAgentFirm(props: CreateAgentFirmProps) {
  const response = await fetcher(API_BASE_PATH, {
    method: 'POST',
    body: props,
  });

  if (!response.ok) {
    const data = await response.json();
    return {
      success: false,
      error: data?.message || 'Failed to create agent firm',
      statusCode: response.status,
    };
  }

  const data = await response.json();
  return {
    success: true,
    data: data.agentFirm,
  };
}
